import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function ReverseEtlIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 40 40" fill="none" {...props}>
      <Box
        as="path"
        fill="currentColor"
        d="M13.982 4.458a16.669 16.669 0 0 1 9.898-.667 16.671 16.671 0 0 1 8.09 4.614l.434.463.107.133a1.669 1.669 0 0 1-.234 2.222 1.669 1.669 0 0 1-2.233-.007l-.12-.122-.348-.37A13.336 13.336 0 0 0 6.666 20.1a13.337 13.337 0 0 0 16.631 12.82 13.335 13.335 0 0 0 6.756-4.163 1.667 1.667 0 0 1 2.515 2.189 16.67 16.67 0 0 1-18.354 4.684A16.67 16.67 0 0 1 3.332 20.124a16.669 16.669 0 0 1 10.65-15.666Z"
      />
      <Box
        as="path"
        fill="currentColor"
        d="M21.665 25a1.667 1.667 0 0 1 0 3.334h-6.667a1.667 1.667 0 0 1 0-3.334h6.667Zm4.318-8.637c-.806-1.428.717-3.039 2.187-2.315l8.84 4.352c1.232.607 1.242 2.36.018 2.982l-8.894 4.513c-1.46.742-3.002-.848-2.216-2.285l1.6-2.924a1.665 1.665 0 0 0-.01-1.618l-1.525-2.705Zm-12.65 1.971a1.667 1.667 0 0 1 0 3.333h-1.667a1.667 1.667 0 0 1 0-3.333h1.667Zm9.337.008a1.667 1.667 0 0 1-.17 3.325h-4.167a1.667 1.667 0 1 1 0-3.333H22.5l.17.008Zm-2.5-6.667A1.667 1.667 0 0 1 20 15h-5a1.667 1.667 0 0 1 0-3.333h5l.17.008Z"
      />
    </Icon>
  );
}
